export default __webpack_public_path__ + "static/media/d4756b676771b5674c40f907fdacd015.5b206418.svg";